<div class="p-4 flex flex-col gap-y-4 basis-full flex-grow app-full-height">
  <h1>Contract Status Report</h1>

  <form [formGroup]="reportForm" (ngSubmit)="getDockets()" #formContainer>
    <div fxLayout="row">
      <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="1 1 100" class="dashboard-filter">
        <report-criteria [availableCriteria]="availableCriteria" [criteriaForm]="reportForm"
          fxFlex="100"></report-criteria>
      </div>
      <div fxFlex="0 0 100" fxFlex.gt-sm="0 0 auto" fxLayout="column" fxLayoutGap="8px" fxLayoutAlign="center end">
        <div fxLayout.gt-sm="row" fxLayout="column" fxLayoutGap="8px" fxLayoutAlign="end start">
          <button mat-flat-button id="bulk-update" color="primary" *ngIf="showBulkUpdateButton" type="button"
            (click)="showStatusUpdateDialog()" [disabled]="selectedRows.length === 0">
            Update status
          </button>
          <button mat-flat-button color="primary" id="generate-report" [disabled]="!reportForm.valid">
            Generate
          </button>
          <button type="button" (click)="getDockets(true)" mat-flat-button id="export-report"
            [disabled]="!reportForm.valid">
            Export
          </button>
        </div>
      </div>
    </div>
  </form>

  <div class="flex flex-row basis-full flex-grow">
    <ag-grid-angular #agGrid [ngStyle]="{ 'height.%': 100, 'width.%': '100' }" class="ag-theme-alpine"
      [columnDefs]="columns" [gridOptions]="gridOptions"></ag-grid-angular>
  </div>
</div>